import React from 'react';
import { ORDER_TRACKING, SOURCE, badgeStyle } from '../../lib/statusConfig';

export function StatusBadge({ status, className = '', testId }) {
    const cfg = ORDER_TRACKING[status];
    if (!cfg) return <span className="text-xs text-[#6B7280]">—</span>;
    return (
        <span
            data-testid={testId || 'status-badge'}
            data-status={status}
            style={badgeStyle(cfg.color)}
            className={`inline-flex items-center h-6 px-2.5 text-xs font-medium ${className}`}
        >
            {cfg.label}
        </span>
    );
}

export function SourceBadge({ source, testId }) {
    const cfg = SOURCE[source];
    if (!cfg) return <span className="text-xs text-[#6B7280]">—</span>;
    return (
        <span
            data-testid={testId || 'source-badge'}
            data-source={source}
            style={badgeStyle(cfg.color)}
            className="inline-flex items-center h-6 px-2.5 text-xs font-medium"
        >
            {cfg.label}
        </span>
    );
}
